<template>
    <!-- 团队预存记录 -->
    <div>
        <div v-if="!applicationPrePage && !transferPrestoreVisible">
            <el-card shadow="never" class="real_card">
                <div slot="header" class="clearfix">
                    <div class="desciconLarge"></div>
                    <span class="font18">财务中心</span>
                </div>
                <div class="assets-box" v-if="userInfo.characterRole == 1 || userInfo.characterRole == 2">
                    <div class="assets-item" v-loading="loading">
                        <div class="assets-label">
                            <span>账户余额</span>
                            <div class="assets-money">￥ {{ (teamInfo.depositAdvance + teamInfo.cashCouponBalance).toFixed(2) || '0.00' }} </div>
                            <el-tooltip class="item" effect="dark" :content="`账户余额为：预存余额￥${ teamInfo.depositAdvance } + 赠送金￥${ teamInfo.cashCouponBalance }（赠送金只能支付订单和补差价，不参与还款、活动等其他福利）`" placement="bottom">
                                <i class="el-icon-warning"></i>
                            </el-tooltip>
                        </div>
                        <div style="display: flex; column-gap: 10px;">
                            <div style="flex: 1;"><el-button type="success" size="small"  @click="applyPrestore">申请预存</el-button></div>
                            <div style="flex: 1;"><el-button type="success" size="small"  @click="transferDeposit">个人预存转团队</el-button></div>
                            <div style="flex: 1;"><el-button type="success" size="small"  @click="transferHandle">预存划拨</el-button></div>
                        </div>
                    </div>
                    <div class="assets-item" v-loading="loading">
                        <div class="assets-label">
                            <span>待入帐</span>
                            <div class="assets-money">￥ {{ teamInfo.teamOrClientInvoiceDebt || '0.00' }} </div>
                            <el-tooltip class="item" effect="dark" content="已开发票但未入账金额" placement="bottom">
                                <i class="el-icon-warning"></i>
                            </el-tooltip>
                        </div>
                        <el-button type="primary" size="small" @click="toMyInvoice">上传凭证</el-button>
                    </div>
                    <div class="assets-item" v-loading="loading">
                        <div class="assets-label">
                            <span>信用余额</span>
                            <div class="assets-money">￥ {{ (teamInfo.lineCredit - teamInfo.toBePaidDebt).toFixed(2) }} </div>
                            <el-tooltip class="item" effect="dark" :content="`信用余额为：授信总额￥${ teamInfo.lineCredit } - 团队信用欠款￥${ teamInfo.toBePaidDebt }`" placement="bottom">
                                <i class="el-icon-warning"></i>
                            </el-tooltip>
                        </div>
                        <el-button type="success" size="small" @click="toRepay">立即还款</el-button>
                    </div>
                    <div class="assets-item" v-loading="loading">
                        <div class="assets-label">
                            <span>团员信用消费</span>
                            <div class="assets-money">￥ {{ teamInfo.teamMemberDebtTotal || '0.00' }} </div>
                        </div>
                        <el-button type="primary" size="small" @click="toHelpRepay">帮ta还款</el-button>
                    </div>
                    <div class="assets-item" v-loading="loading">
                        <div class="assets-label">
                            <span>待开发票</span>
                            <div class="assets-money">￥ {{ teamInfo.teamCanInvoiceTotal || '0.00' }} </div>
                        </div>
                        <el-button type="primary" size="small" @click="toApplyInvoice">去开票</el-button>
                    </div>
                </div>
            </el-card>
            <el-card shadow="never" class="real_card" style="margin-top: 20px" v-if="userInfo.characterRole == 1 || userInfo.characterRole == 2">
                <el-tabs v-model="activeName" type="card">
                    <el-tab-pane label="团队预存使用记录" name="first">
                        <teamPreUsageRecord v-if="activeName == 'first'"></teamPreUsageRecord>
                    </el-tab-pane>
                    <el-tab-pane label="团队信用使用记录" name="second">
                        <teamCreditUsageRecord v-if="activeName == 'second'"></teamCreditUsageRecord>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </div>

        <!-- 预存有礼 -->
        <applicationPre v-if="applicationPrePage" ref="applicationPre" @goBack="applicationPrePage = false" @backAndRefresh="backAndRefresh"></applicationPre>
        <!-- 预存划拨 -->
        <prestoreTransfer v-if="transferPrestoreVisible" ref="prestoreTransfer" @back="back"></prestoreTransfer>
        <!-- 个人预存转团队预存 -->
        <transferDeposit v-if="transferDepositVisible" @close="closeDepo" ref="transferDeposit"></transferDeposit>
    </div>
</template>
<script>
import { teamPrestoreRecord, getFinancialCenterInfo, teamInfo } from '@/api/request';
import { getClient } from '@/plugins/auth';
import applicationPre from "./formPop/applicationPre.vue";
import prestoreTransfer from './formPop/prestoreTransfer';
import teamPreUsageRecord from './formPop/teamPreUsageRecord.vue';
import teamCreditUsageRecord from './formPop/teamCreditUsageRecord.vue';
import transferDeposit from './formPop/transferDeposit'
export default {
    components: {
        teamPreUsageRecord,
        teamCreditUsageRecord,
        applicationPre,
        prestoreTransfer,
        transferDeposit
    },
    data() {
        return {
            loading: true,
            tableData: [],
            teamInfo: {},
            userInfo: JSON.parse(getClient()),
            total: 0,
            pageNum: 1,
            pageSize: 10,
            activeName: 'first',
            applicationPrePage: false,
            transferDepositVisible: false,
            transferPrestoreVisible: false
        };
    },
    mounted() {
        this.getFinancialInfo();
    },
    methods: {
        back() {
            this.applicationPrePage = false;
            this.transferPrestoreVisible = false;
            this.getFinancialInfo();
        },
        //预存有礼
        applyPrestore() {
            this.applicationPrePage = true;
        },
        transferDeposit(){
          this.transferDepositVisible = true;
            this.$nextTick(() => {
                this.$refs.transferDeposit.init();
            });
        },
        closeDepo(){
          this.transferDepositVisible = false
          this.getFinancialInfo()
        },
        //预存划拨
        transferHandle() {
            this.transferPrestoreVisible = true;
            this.$nextTick(() => {
                this.$refs.prestoreTransfer.init();
            });
        },
        async getFinancialInfo() {
            try {
                this.loading = true
                const res_team = await teamInfo(this.userInfo.teamId)
                this.teamInfo = res_team.data;
                this.loading = false
            }
            catch(err) {
                this.loading = false
                console.log(err)
            }
        },
        getList() {
            teamPrestoreRecord({ teamId: this.userInfo.teamId }).then((res) => {
                this.tableData = res.rows;
                this.total = res.total;
            });
        },
        selPageChange(page) {
            this.pageNum = page;
            this.getList();
        },
        toYc() {
            let url = '/aboutUsIndex?type=13&tabIndex=1-1&tabName=%E6%88%91%E7%9A%84%E8%B5%84%E4%BA%A7'
            window.location.href = url
            // window.location.href = 'https://www.navi-sci.cn/aboutUsIndex?type=13&tabIndex=1-1&tabName=%E6%88%91%E7%9A%84%E8%B5%84%E4%BA%A7';
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getList();
        },
        backAndRefresh() {
            this.applicationPrePage = false
            this.getFinancialInfo();
            this.getList();
        },
        //前往【我的发票】
        toMyInvoice() {
          this.$emit('gotoPage', '3-2')
        },
        //前往【立即还款】---团队
        toRepay() {
          this.$emit('gotoPage', '4-5', 'teamOrderOperate', 0)
        },
        //前往【帮ta还款】
        toHelpRepay() {
            this.$emit('gotoPage', '4-5', 'teamOrderOperate', 1)
        },
        //去开票
        toApplyInvoice() {
          this.$emit('gotoPage', '4-5', 'teamOrderOperate', 2)
        }
    }
};
</script>

<style lang="scss" scoped>
.assets-box {
    display: flex;
    column-gap: 20px;
    justify-content: space-between;
    .assets-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        row-gap: 10px;
        justify-content: center;
        align-items: center;
        height: 100px;
        border-radius: 5px;
        border: 1px solid #ddd;
        .assets-label {
            display: flex;
            column-gap: 10px;
            justify-content: space-around;
            align-items: center;
            font-size: 1em;
            .assets-money {
                font-size: 1em;
                font-weight: 600;
                color: #5CC300;
            }
        }
        .el-icon-warning {
            cursor: pointer;
        }
    }
    .assets-item:hover {
        background-color: #84B7F930;
    }
}
</style>
